import { render, staticRenderFns } from "./AddingItemsSection.vue?vue&type=template&id=06af34be&scoped=true&"
import script from "./AddingItemsSection.vue?vue&type=script&lang=js&"
export * from "./AddingItemsSection.vue?vue&type=script&lang=js&"
import style0 from "./AddingItemsSection.vue?vue&type=style&index=0&id=06af34be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af34be",
  null
  
)

export default component.exports